const features = {
  theShop: 'theShop',
  candleSubscription: 'candleSubscription',
  fragranceFamiliesPage: 'fragranceFamiliesPage',
  noteLibPages: 'noteLibPages',
  addQuebecToCanada: 'addQuebecToCanada',
  recurlyKountDDC: 'recurlyKountDDC', // EP-1113
  privateSale: 'privateSale', // EP-730
  twoThreePerfumesPopup: 'twoThreePerfumesPopup',
  wallet: 'wallet',
  defaultCoupon50: 'defaultCoupon50', // PF-892
  hideCancelSubscriptionButton: 'hideCancelSubscriptionButton', // EP-1424
  additionalResubscribePopup: 'additionalResubscribePopup', // EP-1450
  jasonWuGwp: 'JasonWuGwp', // SB-2811
  cashbirdSubscriptionSettings: 'cashbirdSubscriptionSettings', // PF-1155
  giftSubscriptionBanner: 'giftSubscriptionBanner', // EP-1904
  newLastShipmentReviewLogic: 'newLastShipmentReviewLogic', // SB-3795
  scentPreferences: 'scentPreferences', // EP-1630
  serviceWorker: 'serviceWorker', // EP-1603
  loqateAutocomplete: 'loqateAutocomplete', // PF-1152
  giftSetsPage: 'giftSetsPage',
  multipleMerchantsForAmazonPay: 'multipleMerchantsForAmazonPay', // EP-1369
  fragranceCatalogStickyFooter: 'fragranceCatalogStickyFooter', // EP-1446,
  mobileAppPopup: 'mobileAppPopup', // PF-545, PF-1277
  theEdit: 'theEdit', // PF-1242
  ecommercePrefix: 'ecommercePrefix', // PF-1352
  featuredBrand: 'featuredBrand', // PF-408
  candleClubMoreBanners: 'candleClubMoreBanners', // CRO-26
  websiteTakeoverHarmonist: 'websiteTakeoverHarmonist', // PF-1337
  partytown: 'partytown', // PF-1185
  techCartContinueBar: 'techCartContinueBar', // CRO-72
  collaborationSaks: 'collaborationSaks', // PF-1389
  giftCardFraud: 'giftCardFraud', // EP-1846
  optInPopups: 'optInPopups', // PF-1279
  freeShippingProgressBar: 'freeShippingProgressBar', // EP-1845
  websiteTakeoverDOS: 'websiteTakeoverDOS', // PF-1436
  caseSubPromoPopup: 'caseSubPromoPopup', // EP-1839
  magicLinkWeb: 'magicLinkWeb', // EP-1869
  popupsLoader: 'popupsLoader',
  cotyNYNJ: 'cotyNYNJ', // PF-1411
  strapiBanners: 'strapiBanners', // PF-1464
  websiteTakeoverCommodity: 'websiteTakeoverCommodity', // PF-1504
  physicalRebrandCase: 'physicalRebrandCase', // PF-1431
  holiday: 'holidaygifthub22', // EP-1935
  holiday22SaleBadge15: 'holiday22SaleBadge15', // EP-1931
  holiday22SaleBadge20: 'holiday22SaleBadge20', // EP-1931
  holidayCatalogue: 'holidayCatalogue', // EP-1939
  holiday22Sub60: 'holiday22Sub60', // EP-1916
  holiday22CardUpdate60: 'holiday22CardUpdate60', // EP-1925
  holiday22Resubscribe60: 'holiday22Resubscribe60', // EP-1924
  giftSetProductPage: 'giftSetProductPage', // EP-2005
  holiday22BrandedGWP: 'holiday22BrandedGWP', // PF-1569
  holiday22GiftSubscriptionOffer: 'holiday22GiftSubscriptionOffer', // PF-1570
  holidayBannerUpdate: 'holidayBannerUpdate', // EP-1977
  holidayBannerUpdateV2: 'holidayBannerUpdateV2', // EP-2007
  giftSubscriptionOfferTest: 'giftSubscriptionOfferTest', // PF-1550
  websiteTakeoverSanctuary: 'websiteTakeoverSanctuary', // PF-1544
  seoStrapi: 'seoStrapi', // EP-1823
  cartEcommercePromos: 'cartEcommercePromos', // PF-1564
  cacheForBots: 'cacheForBots', // EP-1962
} as const


export type FeatureName = typeof features[keyof typeof features]

export default features
